import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { TextInput } from '@resurs-internal/styx-react'
import { useEventStream } from './stream'
import { Callback } from './Callback'
import { MessageViewer } from './MessageViewer'
import styles from './StoreEvents.module.scss'

export const StoreEvents = () => {
  const { storeId } = useParams()
  const [messages, callbacks] = useEventStream(storeId)
  const [smsFilter, setSmsFilter] = useState('')
  const [callbackFilter, setCallbackFilter] = useState('')

  const processMessages = (sorting, filtering) => {
    const sortedMessages = messages.slice().sort(sorting)
    return sortedMessages.filter(filtering)
  }

  const processCallbacks = (sorting, filtering) => {
    const sortedCallbacks = callbacks.slice().sort(sorting)
    return sortedCallbacks.filter(filtering)
  }

  const sortByCreated = (a, b) => new Date(b.created) - new Date(a.created)

  const filterAll = (object = {}, searchString = '') =>
    !!Object.keys(object).find(key =>
      `${object[key] || ''}`.toLowerCase().includes(searchString.toLowerCase()),
    )

  const filterMessages = message => filterAll(message, smsFilter)

  const filterCallbacks = callback => filterAll(callback, callbackFilter)

  const setSmsFilterText = (id, value) => {
    if (value.length > 2) {
      setSmsFilter(value)
    }
    if (value === '') {
      setSmsFilter('')
    }
  }

  const setCallbackFilterText = (id, value) => {
    if (value.length > 2) {
      setCallbackFilter(value)
    }
    if (value === '') {
      setCallbackFilter('')
    }
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Store events</h1>
      <div className={styles.messages}>
        <h2>Sms messages</h2>
        <div className={styles.textInputWrapper}>
          <TextInput
            id="search-sms"
            kind="search"
            label="Filter sms messages"
            value={smsFilter}
            onChange={setSmsFilterText}
            disableAutocomplete
          />
        </div>
        {!messages.length && <div>No messages</div>}
        {processMessages(sortByCreated, filterMessages).map(item => (
          <div
            className={styles.box}
            key={[item.id, item.created, item.phoneNumber].join('_')}
          >
            <MessageViewer
              message={item.message}
              number={item.phoneNumber}
              created={item.created}
            />
          </div>
        ))}
      </div>
      <div className={styles.callbacks}>
        <h2>Callbacks</h2>
        <div className={styles.textInputWrapper}>
          <TextInput
            id="search-callbacks"
            kind="search"
            label="Filter callbacks"
            value={callbackFilter}
            onChange={setCallbackFilterText}
            disableAutocomplete
          />
        </div>
        {!callbacks.length && <div>No callbacks</div>}
        {processCallbacks(sortByCreated, filterCallbacks).map(item => (
          <div
            className={styles.box}
            key={[item.id, item.created, item.type].join('_')}
          >
            <Callback
              applicationId={item.id}
              type={item.type}
              created={item.created}
              status={item.status}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
